import { render, staticRenderFns } from "./RigaCarrello.vue?vue&type=template&id=023f9ea2&scoped=true&"
import script from "./RigaCarrello.vue?vue&type=script&lang=js&"
export * from "./RigaCarrello.vue?vue&type=script&lang=js&"
import style0 from "./RigaCarrello.vue?vue&type=style&index=0&id=023f9ea2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f9ea2",
  null
  
)

export default component.exports